import { render, staticRenderFns } from "./circleNotifications.vue?vue&type=template&id=1a9d6c9a"
import script from "./circleNotifications.vue?vue&type=script&lang=js"
export * from "./circleNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports